/**
 * Legal pages, rendered from the markdown in /legal.
 *
 * Imported from the repo-root documents rather than copies, so the text a
 * customer agrees to and the text a lawyer reviews cannot drift apart.
 */
import { marked } from 'marked'
import terms from '../../../legal/TERMS.md?raw'
import acceptableUse from '../../../legal/ACCEPTABLE-USE.md?raw'
import privacy from '../../../legal/PRIVACY.md?raw'
import refunds from '../../../legal/REFUNDS.md?raw'
import dmca from '../../../legal/DMCA.md?raw'
import trademark from '../../../legal/TRADEMARK.md?raw'

export interface LegalPage {
  readonly slug: string
  readonly title: string
  readonly html: string
}

marked.setOptions({ gfm: true, breaks: false })

function page(slug: string, title: string, source: string): LegalPage {
  return { slug, title, html: marked.parse(source) as string }
}

export const LEGAL_PAGES: readonly LegalPage[] = [
  page('terms', 'Terms of Service', terms),
  page('acceptable-use', 'Acceptable Use', acceptableUse),
  page('privacy', 'Privacy', privacy),
  page('refunds', 'Refunds', refunds),
  page('dmca', 'Copyright', dmca),
  page('trademark', 'Trademark', trademark),
]

export function findLegalPage(pathname: string): LegalPage | undefined {
  const slug = pathname.replace(/^\/+|\/+$/g, '')
  return LEGAL_PAGES.find((p) => p.slug === slug)
}
